import { useState } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import api from '../../services/api';

export default function DayHeader({ day, users, dayInfo, teamLocations, onReload, onPause }) {
    const [editingAstreinte, setEditingAstreinte] = useState(false);
    const [editingLocation, setEditingLocation] = useState(false);
    const [newLocation, setNewLocation] = useState({ personne: '', lieu: '' });

    const dateStr = format(day, 'yyyy-MM-dd');

    const handleAstreinteChange = async (userId) => {
        try {
            if (dayInfo) {
                await api.patch(`/day_infos/${dayInfo.id}`, {
                    astreinte: userId ? `/api/users/${userId}` : null,
                }, { headers: { 'Content-Type': 'application/merge-patch+json' } });
            } else {
                await api.post('/day_infos', {
                    date: dateStr,
                    astreinte: userId ? `/api/users/${userId}` : null,
                }, { headers: { 'Content-Type': 'application/ld+json' } });
            }
            onReload();
            setEditingAstreinte(false);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddLocation = async (e) => {
        e.preventDefault();
        try {
            await api.post('/team_locations', {
                date: dateStr,
                personne: newLocation.personne,
                lieu: newLocation.lieu,
            }, { headers: { 'Content-Type': 'application/ld+json' } });
            setNewLocation({ personne: '', lieu: '' });
            setEditingLocation(false);
            onReload();
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteLocation = async (id) => {
        try {
            await api.delete(`/team_locations/${id}`);
            onReload();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div style={{ marginBottom: '12px' }}>
            <div style={{textAlign: 'center', marginBottom: '8px'}}>
                <div style={{
                    fontSize: '11px',
                    textTransform: 'uppercase',
                    color: 'var(--text-muted)',
                    fontWeight: '600'
                }}>
                    {format(day, 'EEEE', {locale: fr})}
                </div>
                <div style={{fontSize: '20px', fontWeight: '700', color: 'var(--text-main)'}}>
                    {format(day, 'd')}
                </div>
            </div>

            <div style={{
                color: 'var(--accent-color)',
                borderRadius: '6px',
                padding: '4px 8px',
                marginBottom: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
            }}
                 onClick={() => setEditingAstreinte(!editingAstreinte)}
            >
                <span style={{ fontSize: '11px', fontWeight: '700', color: '#4f46e5' }}>ASTREINTE</span>
                <span style={{ fontSize: '12px', color: '#4f46e5', fontWeight: '600' }}>
          {dayInfo?.astreinte?.nom || '—'}
        </span>
            </div>

            {editingAstreinte && (
                <select
                    onChange={e => handleAstreinteChange(e.target.value)}
                    style={{
                        width: '100%', padding: '6px', borderRadius: '6px',
                        border: '1px solid var(--border-default)', fontSize: '13px',
                        marginBottom: '6px', backgroundColor: 'var(--input-bg)', color: 'var(--text-main)',
                    }}
                    defaultValue=""
                >
                    <option value="">— Aucune —</option>
                    {users.map(u => (
                        <option key={u.id} value={u.id}>{u.nom}</option>
                    ))}
                </select>
            )}

            {teamLocations.map(loc => (
                <div key={loc.id} style={{
                    backgroundColor: '#fef9c3',
                    borderRadius: '6px',
                    padding: '3px 8px',
                    marginBottom: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#854d0e',
                }}>
                    <span>{loc.personne} → {loc.lieu}</span>
                    <span onClick={() => handleDeleteLocation(loc.id)} style={{ cursor: 'pointer', color: '#aaa', marginLeft: '6px' }}>×</span>
                </div>
            ))}

            {editingLocation ? (
                <form onSubmit={handleAddLocation} style={{ marginBottom: '6px' }}>
                    <input
                        placeholder="Personne"
                        value={newLocation.personne}
                        onChange={e => setNewLocation({ ...newLocation, personne: e.target.value })}
                        onFocus={() => onPause(true)}
                        onBlur={() => onPause(false)}
                        style={{
                            width: '100%', padding: '4px 8px', borderRadius: '6px',
                            border: '1px solid var(--border-default)', fontSize: '12px',
                            marginBottom: '4px', boxSizing: 'border-box',
                            backgroundColor: 'var(--input-bg)', color: 'var(--text-main)',
                        }}
                        required
                    />
                    <input
                        placeholder="Lieu"
                        value={newLocation.lieu}
                        onChange={e => setNewLocation({ ...newLocation, lieu: e.target.value })}
                        onFocus={() => onPause(true)}
                        onBlur={() => onPause(false)}
                        style={{
                            width: '100%', padding: '4px 8px', borderRadius: '6px',
                            border: '1px solid var(--border-default)', fontSize: '12px',
                            marginBottom: '4px', boxSizing: 'border-box',
                            backgroundColor: 'var(--input-bg)', color: 'var(--text-main)',
                        }}
                        required
                    />
                    <div style={{display: 'flex', gap: '4px'}}>
                        <button type="submit" style={{
                            flex: 1,
                            padding: '4px',
                            backgroundColor: '#4f46e5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '12px',
                            cursor: 'pointer'
                        }}>Ajouter
                        </button>
                        <button type="button" onClick={() => setEditingLocation(false)} style={{
                            flex: 1, padding: '4px', backgroundColor: 'var(--hover-bg)', color: 'var(--text-main)',
                            border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer',
                        }}>Annuler
                        </button>
                    </div>
                </form>
            ) : (
                <button
                    onClick={() => setEditingLocation(true)}
                    style={{
                        width: '100%', padding: '3px', backgroundColor: 'transparent',
                        border: '1px dashed var(--border-default)', borderRadius: '6px',
                        fontSize: '11px', color: 'var(--text-muted)', cursor: 'pointer', marginBottom: '6px',
                    }}
                >
                    + Localisation
                </button>
            )}
        </div>
    );
}